import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProjectProvider } from './contexts/ProjectContext';
import { I18nProvider } from './i18n/I18nContext';
import { AppConfigProvider } from './i18n/AppConfigProvider';
import PrivateRoute from './components/PrivateRoute';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import Login from './pages/Login';
import HowItWorks from './pages/HowItWorks';
import Why from './pages/Why';
import Blog from './pages/Blog';
import BlogArticle from './pages/BlogArticle';
import Dashboard from './pages/Dashboard';
import Invoices from './pages/Invoices';
import Clients from './pages/Clients';
import CreateInvoice from './pages/CreateInvoice';
import Ledger from './pages/Ledger';
import Withdraws from './pages/Withdraws';
import CreateWithdraw from './pages/CreateWithdraw';
import Settings from './pages/Settings';
import Pro from './pages/Pro';
import AdminWithdraws from './pages/AdminWithdraws';
import AdminUsers from './pages/AdminUsers';
import Redirects from './pages/Redirects';
import RedirectResolve from './pages/RedirectResolve';
import Layout from './components/Layout';
import { getTelegramStartParam, resolveStartParamRoute } from './telegram/webApp';

const StarsSolution = React.lazy(() => import('./pages/StarsSolution'));

/** Route par défaut de /app : respecte le start_param Telegram (ex. ?startapp=lien → créer un lien). */
const AppIndexRedirect: React.FC = () => (
  <Navigate to={resolveStartParamRoute(getTelegramStartParam()) || '/app/dashboard'} replace />
);

function App() {
  return (
    <I18nProvider>
      <AppConfigProvider>
        <ErrorBoundary>
          <AuthProvider>
          <ProjectProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/r/:slug" element={<RedirectResolve />} />
              <Route path="/login" element={<Login />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/how-it-works/" element={<HowItWorks />} />
              <Route path="/why" element={<Why />} />
              <Route path="/why/" element={<Why />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogArticle />} />
              <Route path="/blog/:slug/" element={<BlogArticle />} />
              <Route
                path="/:locale/lien-paiement-telegram-stars"
                element={
                  <React.Suspense fallback={null}>
                    <StarsSolution />
                  </React.Suspense>
                }
              />
              <Route
                path="/:locale/lien-paiement-telegram-stars/"
                element={
                  <React.Suspense fallback={null}>
                    <StarsSolution />
                  </React.Suspense>
                }
              />
              <Route
                path="/app"
                element={
                  <PrivateRoute>
                    <Layout />
                  </PrivateRoute>
                }
              >
                <Route index element={<AppIndexRedirect />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="invoices" element={<Invoices />} />
                <Route path="invoices/new" element={<CreateInvoice />} />
                <Route path="clients" element={<Clients />} />
                <Route path="ledger" element={<Ledger />} />
                <Route path="withdraws" element={<Withdraws />} />
                <Route path="withdraws/new" element={<CreateWithdraw />} />
                <Route path="redirects" element={<Redirects />} />
                <Route path="settings" element={<Settings />} />
                <Route path="pro" element={<Pro />} />
                <Route path="admin/withdraws" element={<AdminWithdraws />} />
                <Route path="admin/users" element={<AdminUsers />} />
              </Route>
            </Routes>
          </Router>
          </ProjectProvider>
          </AuthProvider>
        </ErrorBoundary>
      </AppConfigProvider>
    </I18nProvider>
  );
}

export default App;
